const GRUPA_REJESTROWA__LABELS: Record<number, string> = {
	1: "Skarb Państwa (bez użytkowników wieczystych)",
	2: "Skarb Państwa (oddane w użytkowanie wieczyste)",
	3: "Jednoosobowe spółki SP, przedsiębiorstwa państwowe i inne państwowe osoby prawne",
	4: "Gminy i związki międzygminne (bez użytkowników wieczystych)",
	5: "Gminy i związki międzygminne (oddane w użytkowanie wieczyste)",
	6: "Spółki JST i inne samorządowe osoby prawne",
	7: "Osoby fizyczne",
	8: "Spółdzielnie",
	9: "Kościoły i związki wyznaniowe",
	10: "Wspólnoty gruntowe",
	11: "Powiaty (bez użytkowników wieczystych)",
	12: "Powiaty (oddane w użytkowanie wieczyste)",
	13: "Województwa (bez użytkowników wieczystych)",
	14: "Województwa (oddane w użytkowanie wieczyste)",
	15: "Spółki prawa handlowego",
	16: "Inne podmioty (niewymienione w 1–15)",
};

const GRUPA_REJESTROWA__OPTIONS: Array<{ code: number; label: string }> = Object.entries(GRUPA_REJESTROWA__LABELS).map(([code, label]) => ({
	code: Number(code),
	label,
}));

export { GRUPA_REJESTROWA__LABELS, GRUPA_REJESTROWA__OPTIONS };
